import MealtimesView from './MealtimesView';

export default MealtimesView;
